export const SET_TREE = "SET_TREE";
export const SET_CURRENT_NODE = "SET_CURRENT_NODE";
export const SET_CURRENT_UI_NODE = "SET_CURRENT_UI_NODE";
export const SET_SCHEMA_CODE = "SET_SCHEMA_CODE";
export const SET_UISCHEMA_CODE = "SET_UISCHEMA_CODE";
export const SET_ERROR = "SET_ERROR";
